/**
 * Hook de tracking de páginas para el reporte de tráfico.
 * Detecta el tipo de página desde la URL y envía al backend.
 */
import { useEffect } from 'react';

const TRACKING_ENABLED = process.env.GATSBY_TRACKING_ENABLED !== 'false';
const BASE_URL = process.env.BASE_URL || '';

function getSessionId() {
  if (typeof localStorage === 'undefined') return null;
  let sid = localStorage.getItem('_tracking_session');
  if (!sid) {
    sid = Math.random().toString(36).substring(2) + Date.now().toString(36);
    localStorage.setItem('_tracking_session', sid);
  }
  return sid;
}

// También lo usa Mixpanel (utils/mixpanel.js) para el tipo de página.
export function detectPageType(pathname) {
  if (!pathname) return { page_type: 'other', entity_slug: null };
  if (pathname === '/' || pathname === '') return { page_type: 'home', entity_slug: null };
  if (pathname.startsWith('/categoria-producto/')) return { page_type: 'category', entity_slug: pathname.replace('/categoria-producto/', '').replace(/\/$/, '') };
  if (pathname.startsWith('/producto/')) return { page_type: 'product', entity_slug: pathname.replace('/producto/', '').replace(/\/$/, '') };
  if (pathname.startsWith('/marca/')) return { page_type: 'brand', entity_slug: pathname.replace('/marca/', '').replace(/\/$/, '') };
  if (pathname.startsWith('/tag/') || pathname.startsWith('/etiqueta/')) return { page_type: 'tag', entity_slug: pathname.split('/').filter(Boolean).pop() };
  if (pathname.startsWith('/checkout')) return { page_type: 'checkout', entity_slug: null };
  if (pathname.startsWith('/cart') || pathname.startsWith('/carrito')) return { page_type: 'cart', entity_slug: null };
  return { page_type: 'page', entity_slug: pathname.replace(/\/$/, '') };
}

export function trackPageView(pathname) {
  if (!TRACKING_ENABLED || typeof window === 'undefined') return;

  const { page_type, entity_slug } = detectPageType(pathname);
  const session_id = getSessionId();
  const user_id = (() => { try { const u = JSON.parse(localStorage.getItem('user') || 'null'); return u?.id || null; } catch { return null; } })();

  const payload = JSON.stringify({
    page_url: pathname,
    page_type,
    entity_slug,
    session_id,
    user_id,
    referrer: typeof document !== 'undefined' ? document.referrer : null,
  });

  const url = `${BASE_URL}/track/pageview`;

  if (typeof navigator !== 'undefined' && navigator.sendBeacon) {
    navigator.sendBeacon(url, new Blob([payload], { type: 'application/json' }));
  } else {
    fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: payload, keepalive: true }).catch(() => {});
  }
}

export default function usePageTracking(pathname) {
  useEffect(() => {
    trackPageView(pathname);
  }, [pathname]);
}
